import React from "react";
import { useState, useEffect } from "react";

import {
  Form,
  Button,
  Card,
  Col,
  Row,
  Spinner,
  Container,
} from "react-bootstrap";
import Cookies from "js-cookie";

import {
  getRequest,
  deleteRequest,
  postRequest,
} from "../../api/axiosRequests";
import CardOverlay from "../../common/components/CardOverlay";
import AlertModal from "../../common/components/AlertModal";
import { PALETTE } from "../../common/ThemeConstants";

export default function UserWorkoutList({ user }) {
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedWorkout, setSelectedWorkout] = useState(-1);
  const [userWorkouts, setUserWorkouts] = useState([]);
  const [userWorkoutToRemove, setUserWorkoutToRemove] = useState(-1);
  const [workouts, setWorkouts] = useState([]);

  async function fetchData() {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise1 = getRequest("planListForUser/" + user.id, headers);
    const promise2 = getRequest("planList/", headers);
    Promise.all([promise1, promise2])
      .then((values) => {
        const userWorkoutsData = values[0].data;
        const workoutsData = values[1].data;
        const filteredWorkouts = workoutsData.filter((w) => {
          let result = true;
          userWorkoutsData.forEach((userWorkout) => {
            if (userWorkout.plan.id === w.id) {
              result = false;
            }
          });
          return result;
        });
        setUserWorkouts(userWorkoutsData);
        setWorkouts(filteredWorkouts);
      })
      .catch((errs) => {});
  }

  async function deleteCallback(id) {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const response = await deleteRequest("planUser/" + id, headers);
    setShowDeleteForm(false);
    fetchData();
  }

  async function workoutAssociationPostRequest(data) {
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      "X-CSRFToken": csrftoken,
      Authorization: localStorage.getItem("jwt"),
    };
    const response = await postRequest("planUser/", data, headers);
    return response;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedWorkout == -1) {
      return;
    }
    setIsLoading(true);
    const data = {
      user: user.id,
      plan: selectedWorkout,
    };
    workoutAssociationPostRequest(data)
      .then((res) => {
        fetchData();
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="p-1">
      <Container
        className="rounded py-1"
        style={{ backgroundColor: PALETTE.LIGHTGRAY }}
      >
        <Row className="text-start pt-2" style={{ color: PALETTE.DARKGRAY }}>
          <p className="mb-1">Associated workouts:</p>
        </Row>
        <Row className="d-flex flex-nowrap overflow-auto mx-2">
          <AlertModal
            show={showDeleteForm}
            getDataId={() => {
              return userWorkoutToRemove;
            }}
            onHide={() => {
              setShowDeleteForm(false);
            }}
            onCancel={() => {
              setShowDeleteForm(false);
            }}
            onConfirm={() => {
              deleteCallback(userWorkoutToRemove);
            }}
            title={"Delete Workout association"}
            description={
              "Are you sure you want to delete the workout associated with the current user?"
            }
          />
          <Col className="ml-2" style={{ maxWidth: "fit-content" }}>
            <Form
              style={{ width: "175px", height: "175px", maxWidth: "100%" }}
              className="p-2 border rounded my-1"
              onSubmit={handleSubmit}
              action="/private/adminExercises"
            >
              <div>
                <div className="m-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Add workout</Form.Label>
                    <Form.Select
                      aria-label="type"
                      onChange={(event) =>
                        setSelectedWorkout(event.target.value)
                      }
                      value={selectedWorkout}
                    >
                      <option key={0} value={-1}></option>
                      {workouts.map((w) => (
                        <option key={w.id} value={w.id}>
                          {w.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>
              <Button
                className="mt-3"
                style={{ width: "100%" }}
                variant="dark"
                type="submit"
                disabled={isLoading}
              >
                {isLoading && <Spinner animation="border" />}
                {!isLoading && "Save"}
              </Button>
            </Form>
          </Col>
          {userWorkouts.map((w) => (
            <Col
              key={w.id}
              className="ml-1"
              style={{ maxWidth: "fit-content" }}
            >
              <CardOverlay
                height={175}
                width={175}
                close={true}
                className="max-2 bg-dark text-center text-white"
                name={w.plan.name}
                cover={w.plan.cover}
                description={`Scade: ${new Date(w.expire_at).toLocaleString(
                  "it-IT",
                  { year: "numeric", month: "numeric", day: "numeric" }
                )}`}
                onClose={() => {
                  setUserWorkoutToRemove(w.id);
                  setShowDeleteForm(true);
                }}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
